import { getThemeColor, IconButton, useTheme } from '@sparemin/blockhead';
import React, { useCallback, useRef, useState } from 'react';

import { InputAdornment } from 'components/Form';
import { ThinWand } from 'components/icons';
import RenameClipModalRegeneratePopover from './RenameClipModalRegeneratePopover';
import { OnGenerateClipName } from './types';
import { block } from './utils';

export type RenameClipModalInputAdornmentProps = {
  isDisabled: boolean;
  onGenerateClipName: OnGenerateClipName;
};

const RenameClipModalInputAdornment: React.FC<RenameClipModalInputAdornmentProps> = ({
  isDisabled,
  onGenerateClipName,
}) => {
  const [isRegeneratePopoverOpen, setIsRegeneratePopoverOpen] = useState(false);

  const regenerateOptionsButtonsRef = useRef<HTMLButtonElement>(null);

  const theme = useTheme();

  const handleGenerateClipName: OnGenerateClipName = useCallback(
    (formality, tone) => {
      setIsRegeneratePopoverOpen(false);
      onGenerateClipName(formality, tone);
    },
    [onGenerateClipName],
  );

  return (
    <>
      <InputAdornment className={block('adornment')}>
        <IconButton
          ref={regenerateOptionsButtonsRef}
          disabled={isDisabled}
          className={block('adornment-button')}
          onClick={() => setIsRegeneratePopoverOpen(true)}
        >
          <ThinWand
            width={20}
            height={20}
            fill={getThemeColor('d5')({ theme })}
          />
        </IconButton>
      </InputAdornment>

      <RenameClipModalRegeneratePopover
        triggerElement={regenerateOptionsButtonsRef.current}
        isOpen={isRegeneratePopoverOpen}
        onGenerateClipName={handleGenerateClipName}
        onClose={() => setIsRegeneratePopoverOpen(false)}
      />
    </>
  );
};

export default RenameClipModalInputAdornment;
